<div class="wrapper">
    <!-- <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar> -->
    <app-appli-side-bar [sidebars]="sidebar" (focusEventIndex)="setFocusIndex($event)" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar>

    <div class="icon_box">
        <div class="top_icon"></div>
        <div class="app_name">{{ appname }}</div>

    </div>
    <div class="remote_control"></div>

    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>

    <div class="main_content_wrapper">
        <div class="main_content">
            <div *ngIf="hotelIndex == 0">

                <div class="floor_icon">
                    <img src="/assets/icons/com/floor.svg">
                </div>
                <div *ngIf="lang == 'jpn'">


                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">朝食ブッフェ</div>

                            <div class="mess_l">
                                <p>時間｜7:00 ～ 10:00 （ラストオーダー 9:30）</p>
                                <p>会場｜レストラン「穏坐」 - ONZA -</p>
                            </div>

                            <div class="mess_s">
                                <p>京都産の炊きたて白米や白味噌を使った具沢山のお味噌汁、地元の</p>
                                <p>老舗豆腐屋が作る南禅寺豆腐などブッフェスタイルでご用意いたし</p>
                                <p>ます。そのほか、多彩な京風おばんざいやお漬物、和スイーツなど</p>
                                <p>もご一緒にお楽しみいただける「和」の朝ごはんをご堪能ください。</p>
                            </div>

                            <div class="smalltext">
                                <p>※部屋着やスリッパでの来店はご遠慮ください。</p>

                            </div>
                        </div>

                        <div class="right_img img_2p">
                            <img src="/assets/breakfast/breakfast_r.jpg">
                            <img src="/assets/breakfast/dessert.jpg">
                        </div>
                    </div>

                </div>

                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class=" mess_title ">Breakfast Buffet</div>

                            <div class="mess_l">
                                <p>Restaurant「ONZA」</p>
                                <p>7:00 a.m. - 10:00 a.m. (Last Order 9:30 a.m.)</p>
                            </div>

                            <div class="mess_s breakfast_mess_s">
                                <p>We offer freshly cooked rice from Kyoto, miso soup with a variety of</p>
                                <p>ingredients, and Nanzenji Tofu from a long-established tofu shop</p>
                                <p>in Kyoto. We also provide a range of Kyoto-style side dishes, pickles,</p>
                                <p>and Japanese sweets.Additionally, a selection of Kyoto-style obanzai,</p>
                                <p> pickles, and Japanese sweets will be available.</p>

                            </div>

                            <div class="smalltext">
                                <p>※Hotel guests are asked to refrain from wearing pajamas or</p>
                                <p>slippers in the restaurant.</p>

                            </div>
                        </div>

                        <div class="right_img img_2p">
                            <img src="/assets/breakfast/breakfast_r.jpg ">
                            <img src="/assets/breakfast/dessert.jpg ">
                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</div>